import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import WikipediaModal from '../../home/components/wikipediaModal';
import ChecklistModal from '../../home/components/checklistModal';
import EventsApi from '../../../api/eventsApi/eventsApi';
import { fetchWikipediaData } from '../../../api/publicApi/wikipedia';

interface WikipediaData {
    title: string | null;
    summary: string | null;
    thumbnail: string | null;
}

const ReportPages = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [pinData, setPinData] = useState<any>(null);
    const [wikipediaData, setWikipediaData] = useState<WikipediaData>({
        title: null,
        summary: null,
        thumbnail: null
    });
    const [checklistOpen, setChecklistOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!id) return;

            try {
                setLoading(true);
                // Pin detayını tek kaynaktan al (koordinat casing/type farklarından kaçınmak için)
                const pinInfo = await EventsApi.getPinInfo(id);

                const parseNumber = (v: any): number => {
                    if (typeof v === 'number') return v;
                    if (typeof v === 'string') {
                        const t = v.trim().replace(',', '.');
                        const n = Number(t);
                        return n;
                    }
                    return Number(v);
                };

                const rawLat = (pinInfo as any).latitude ?? (pinInfo as any).Latitude;
                const rawLng = (pinInfo as any).longitude ?? (pinInfo as any).Longitude;
                const rawRadius = (pinInfo as any).radiusInMeters ?? (pinInfo as any).RadiusInMeters ?? (pinInfo as any).radius;

                let latitude = parseNumber(rawLat);
                let longitude = parseNumber(rawLng);
                const radiusInMeters = parseNumber(rawRadius);

                // Lat/Lng swap guard (bazı kaynaklarda ters gelebiliyor)
                const latValid = Number.isFinite(latitude) && latitude >= -90 && latitude <= 90;
                const lngValid = Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;
                const latValidIfSwapped = Number.isFinite(longitude) && longitude >= -90 && longitude <= 90;
                const lngValidIfSwapped = Number.isFinite(latitude) && latitude >= -180 && latitude <= 180;
                if ((!latValid || !lngValid) && latValidIfSwapped && lngValidIfSwapped) {
                    const tmp = latitude;
                    latitude = longitude;
                    longitude = tmp;
                }

                const pinWithRadius = {
                    id: (pinInfo as any).id ?? (pinInfo as any).Id,
                    name: (pinInfo as any).name ?? (pinInfo as any).Name,
                    sector: (pinInfo as any).sector ?? (pinInfo as any).Sector,
                    latitude,
                    longitude,
                    radius: radiusInMeters
                };

                console.log('ReportPages pinInfo raw', { rawLat, rawLng, rawRadius, pinInfo });
                console.log('ReportPages pinInfo -> pinWithRadius', pinWithRadius);
                setPinData(pinWithRadius);

                const pinName = (pinInfo as any).name ?? (pinInfo as any).Name;
                if (pinName) {
                    const wikiData = await fetchWikipediaData(pinName);
                    setWikipediaData({
                        title: pinName,
                        summary: wikiData?.extract || pinInfo.QuestionsJson?.wikipediaSummary || null,
                        thumbnail: wikiData?.thumbnail?.source || null
                    });
                }
            } catch (error) {
                console.error('Veri yüklenirken hata:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleOpenChecklist = () => {
        setChecklistOpen(true);
    };

    const handleCloseChecklist = () => {
        setChecklistOpen(false);
    };

    return (
        <>
            <WikipediaModal
                open={!checklistOpen}
                onClose={() => {}}
                onDelete={() => {}}
                onCreateReport={() => {}}
                onOpenChecklist={handleOpenChecklist}
                title={wikipediaData.title}
                loading={loading}
                summary={wikipediaData.summary}
                savedPinData={pinData}
            />
            
            {id && (
                <ChecklistModal
                    open={checklistOpen}
                    onClose={handleCloseChecklist}
                    pinId={id}
                />
            )}
        </>
    );
};

export default ReportPages;
